<template>
  <div class="training-commands">
    <h3 class="title-glow">🎤 Training Agent — Quick Commands</h3>
    <div class="commands-grid">
      <div
        v-for="cmd in commands"
        :key="cmd.command"
        class="command-card"
        @click="runCommand(cmd.command, cmd.label)"
        tabindex="0"
        @keyup.enter="runCommand(cmd.command, cmd.label)"
      >
        <span class="cmd-icon">{{ cmd.icon }}</span>
        <span class="cmd-label">{{ cmd.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingCommands",
  props: {
    startSpeaking: { type: Function, required: true },
    alfred: { type: Function, required: true }, // Pass your AI processing function
    readOutLoud: { type: Function, default: null }
  },
  data() {
    return {
      commands: [
        { icon: "🔍", label: "Google Search", command: "google OpenAI news" },
        { icon: "🎵", label: "Play Song", command: "play song" },
        { icon: "📺", label: "YouTube Search", command: "youtube generative AI documentary" },
        { icon: "📅", label: "Show Calendar", command: "show calendar" },
        { icon: "💡", label: "Turn Lights On", command: "turn lights on" },
        { icon: "🛒", label: "Place Order", command: "place order" },
        { icon: "📊", label: "Generate Report", command: "report sales" },
        { icon: "🕑", label: "Get Time", command: "check for date and time" },
        { icon: "👤", label: "Create Lead", command: "create lead" },
        { icon: "💼", label: "Navigate Dashboard", command: "navigate dashboard" },
        { icon: "📚", label: "Access Knowledge Bank", command: "access knowledge bank" },
        { icon: "💬", label: "Help / What can you do?", command: "help me" },
        { icon: "🎥", label: "Start Video Chat", command: "video chat" },
        { icon: "📝", label: "Create Note", command: "create note" },
        { icon: "🎨", label: "Generate Image", command: "generate image" },
        { icon: "🚦", label: "Start Training", command: "start training" },
        { icon: "📈", label: "Show Analytics", command: "report analytics" },
        { icon: "🔊", label: "Start Assistant", command: "start analyst" },
        { icon: "📞", label: "Call", command: "call John" },
        { icon: "🌙", label: "Lights Night Mode", command: "lights night mode" }
      ]
    };
  },
  methods: {
    runCommand(command, label) {
      // Step 1: Activate mic (show animation, sound, etc)
      if (this.startSpeaking) this.startSpeaking();

      // Step 2: (Optional) Speak the command out loud for feedback
      if (this.readOutLoud) this.readOutLoud(label);

      // Step 3: After a brief delay, pass command to the AI agent
      setTimeout(() => {
        this.alfred(command);
      }, 1000); // Adjust as needed for mic animation
    }
  }
};
</script>

<style scoped>
.training-commands {
  padding: 1.5rem;
  background: rgba(20, 24, 40, 0.95);
  border-radius: 2rem;
  box-shadow: 0 0 32px #00eaff44;
  max-width: 900px;
  margin: 2rem auto;
}
.title-glow {
  font-family: 'Orbitron', 'Rajdhani', monospace;
  color: #00eaff;
  text-align: center;
  letter-spacing: 1px;
  margin-bottom: 1.2rem;
}
.commands-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 1.5rem;
  justify-content: center;
}
.command-card {
  background: linear-gradient(120deg, #202445 80%, #00eaff44 100%);
  border: 1.5px solid #00eaff88;
  border-radius: 1.2rem;
  box-shadow: 0 2px 12px #0ff5 0px;
  padding: 1.2rem 1rem;
  color: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 1.08rem;
  font-family: 'Rajdhani', monospace;
  transition: transform 0.12s, box-shadow 0.18s;
  outline: none;
  user-select: none;
}
.command-card:active, .command-card:focus {
  transform: scale(1.03);
  box-shadow: 0 0 24px #00eaff99;
  border-color: #00eaff;
}
.cmd-icon {
  font-size: 2.2rem;
  display: block;
  margin-bottom: 0.3rem;
  filter: drop-shadow(0 0 8px #00eaff77);
}
.cmd-label {
  display: block;
  margin-top: 0.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
@media (max-width: 700px) {
  .commands-grid {
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 1rem;
  }
  .command-card { font-size: 0.98rem; }
}
</style>
